import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import OperatorTypes from '../../../common/redux/actions/types/OperatorTypes';
import PostalOperatorSelector from '../../../wizard/target-node-impc-selector/components/PostalOperatorSelector';
import {
  getArrivalPostalOperators,
  getDepartureCheckedMailProcessingCenters,
  getDeparturePostalOperators,
  getArrivalCheckedMailProcessingCenters,
  getExpandedArrivalPostalOperators,
  getExpandedDeparturePostalOperatorsOperatorImpcAdmin,
  getSelectedArrivalPostalOperators,
  getSelectedDeparturePostalOperators,
} from '../../../wizard/target-node-impc-selector/redux/selectors/PostalOperatorSelectors';
import {
  retrieveOutboundPostalOperatorsRequestActionCreator,
  departureMailProcessingCenterCheckedActionCreator,
  onDeparturePostalOperatorExpandedAdmin,
  onSelectAllDepartureMailProcessingCenters,
  onDeSelectAllDepartureMailProcessingCenters,
} from '../../../wizard/target-node-impc-selector/redux/actions/DeparturePostalOperatorActions';
import {
  retrieveInboundPostalOperatorsRequestActionCreator,
  arrivalMailProcessingCenterCheckedActionCreator,
  onArrivalPostalOperatorExpanded,
  onSelectAllArrivalMailProcessingCenters,
  onDeSelectAllArrivalMailProcessingCenters,
} from '../../../wizard/target-node-impc-selector/redux/actions/ArrivalPostalOperatorActions';
import { saveGlobalSelectionImpcRequestActionCreator, setTabButtonStatus } from '../redux/actions/AdminDashboardActions';
import AdminPresetOperatorImpcSidebarContainer from './AdminPresetOperatorImpcSidebarContainer';
import { createPresetSelectionsOnSave } from '../../../react-table/helpers/utils';

export class GlobalPresetsOperatorImpcContainer extends Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props);
    this.state = {
      showOnlySelectedDeparturePostalOperators: false,
      showOnlySelectedArrivalPostalOperators: false,
    };
  }

  componentDidMount() {
    const defaultDate = moment();
    this.props.retrieveOutboundPostalOperatorsRequestActionCreator(
      {
        defaultDirection: 'I',
        startDate: defaultDate,
        endDate: defaultDate,
      },
      '',
      '',
    );

    this.props.retrieveInboundPostalOperatorsRequestActionCreator(
      {
        defaultDirection: 'I',
        startDate: defaultDate,
        endDate: defaultDate,
      },
      '',
      '',
    );
  }

  componentDidUpdate(prevProps) {
    if (this.props.departureCheckedMailProcessingCenters !== prevProps.departureCheckedMailProcessingCenters && this.props.departureCheckedMailProcessingCenters.length !== 0) {
      this.props.setTabButtonStatus(true);
    }
    if (this.props.departureCheckedMailProcessingCenters.length === 0 && prevProps.departureCheckedMailProcessingCenters.length !== 0) {
      this.setState({
        showOnlySelectedDeparturePostalOperators: false,
      });
    }
  }

  onSelectAllDeparturePostalOperators = () => {
    this.props.onSelectAllDepartureMailProcessingCenters(this.props.departurePostalOperatorsNodes);
  };

  onSelectAllArrivalPostalOperators = () => {
    this.props.onSelectAllArrivalMailProcessingCenters(this.props.arrivalPostalOperatorsNodes);
  };

  onDeSelectAllDeparturePostalOperators = () => {
    this.setState({
      showOnlySelectedDeparturePostalOperators: false,
    });
    this.props.onDeSelectAllDepartureMailProcessingCenters();
  };

  onDeSelectAllArrivalPostalOperators = () => {
    this.setState({
      showOnlySelectedArrivalPostalOperators: false,
    });
    this.props.onDeSelectAllArrivalMailProcessingCenters();
  };

  onSelectDeparturePostalOperatorOrImpc = (selected) => {
    if (selected.length === 0) {
      this.setState({
        showOnlySelectedDeparturePostalOperators: false,
      });
    }
    // eslint-disable-next-line react/prop-types
    this.props.departureMailProcessingCenterCheckedActionCreator(selected, this.props.report);
  };

  onExpandDeparturePostalOperator = (expanded) => {
    this.props.onDeparturePostalOperatorExpandedAdmin(expanded);
  };

  onExpandArrivalPostalOperator = (expanded) => {
    this.props.onArrivalPostalOperatorExpanded(expanded);
  };

  onToggleShowOnlySelectedDeparturePostalOperators = () => {
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      showOnlySelectedDeparturePostalOperators: !this.state.showOnlySelectedDeparturePostalOperators,
    });
  };

  onToggleShowOnlySelectedArrivalPostalOperators = () => {
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      showOnlySelectedArrivalPostalOperators: !this.state.showOnlySelectedArrivalPostalOperators,
    });
  };

  openSaveSelectionModalForDeparture = () => {
    this.openSaveSelectionModal({
      checkedMailProcessingCenters: createPresetSelectionsOnSave(this.props.departureCheckedMailProcessingCenters, this.props.departurePostalOperatorsNodes),
      selections: this.props.departureSelections,
      postalOperatorType: 'DEPARTURE',
    });
  };

  openSaveSelectionModalForArrival = () => {
    this.openSaveSelectionModal({
      checkedMailProcessingCenters: createPresetSelectionsOnSave(this.props.arrivalCheckedMailProcessingCenters, this.props.arrivalPostalOperatorsNodes),
      selections: this.props.arrivalSelections,
      postalOperatorType: 'ARRIVAL',
    });
  };

  render() {
    const departurePostalOperatorSelectorProps = {
      selected: this.props.departureCheckedMailProcessingCenters,
      expanded: this.props.departureExpandedPostalOperators,
      expandDisabled: false,
      isShowOnlySelected: this.state.showOnlySelectedDeparturePostalOperators,
      postalOperatorNodes: this.state.showOnlySelectedDeparturePostalOperators ?
        this.props.selectedDeparturePostalOperatorsNodes : this.props.departurePostalOperatorsNodes,
      originalPostalOperatorNodes: this.props.departurePostalOperatorsNodes,
      onSelect: this.onSelectDeparturePostalOperatorOrImpc,
      onExpand: this.onExpandDeparturePostalOperator,
      onSelectAll: this.onSelectAllDeparturePostalOperators,
      onDeSelectAll: this.onDeSelectAllDeparturePostalOperators,
      onShowOnlySelected: this.onToggleShowOnlySelectedDeparturePostalOperators,
      openSaveSelectionModal: this.openSaveSelectionModalForDeparture,
      saveSelectionButtonHidden: true,
    };
    /* const arrivalPostalOperatorSelectorProps = {
      selected: this.props.arrivalCheckedMailProcessingCenters,
      expanded: this.props.arrivalExpandedPostalOperators,
      expandDisabled: false,
      isShowOnlySelected: this.state.showOnlySelectedArrivalPostalOperators,
      postalOperatorNodes: this.state.showOnlySelectedArrivalPostalOperators ?
        this.props.selectedArrivalPostalOperatorsNodes : this.props.arrivalPostalOperatorsNodes,
      originalPostalOperatorNodes: this.props.arrivalPostalOperatorsNodes,
      onSelect: this.onSelectArrivalPostalOperatorOrImpc,
      onExpand: this.onExpandArrivalPostalOperator,
      onSelectAll: this.onSelectAllArrivalPostalOperators,
      onDeSelectAll: this.onDeSelectAllArrivalPostalOperators,
      onShowOnlySelected: this.onToggleShowOnlySelectedArrivalPostalOperators,
      openSaveSelectionModal: this.openSaveSelectionModalForArrival,
      saveSelectionButtonHidden: true,
    }; */
    return (
      <div>
        <div className="operator-selector-wrapper">
          <div className="operator-sidebar">
            <AdminPresetOperatorImpcSidebarContainer
              operatorType={OperatorTypes.DEPARTURE}
              operators={this.props.departurePostalOperatorsNodes}
              checked={this.props.departureCheckedMailProcessingCenters}
            />
          </div>
          <div className="operators">
            <div className="operators-selection-panel">
              <div className="operator">
                <PostalOperatorSelector
                  title="OPERATOR/IMPC"
                  {...departurePostalOperatorSelectorProps}
                />
              </div>

              {/* <div className="operator">
                <PostalOperatorSelector
                  title="ARRIVAL OPERATOR"
                  {...arrivalPostalOperatorSelectorProps}
                />
              </div> */}
            </div>
          </div>
          {/* <div className="operator-sidebar">
            <AdminPresetOperatorImpcSidebarContainer
              operatorType={OperatorTypes.ARRIVAL}
              operators={this.props.arrivalPostalOperatorsNodes}
                checked={this.props.arrivalCheckedMailProcessingCenters}
            />
          </div> */}
        </div>
      </div>
    );
  }
}

GlobalPresetsOperatorImpcContainer.propTypes = {
  departurePostalOperatorsNodes: PropTypes.arrayOf(PropTypes.object),
  selectedDeparturePostalOperatorsNodes: PropTypes.arrayOf(PropTypes.object),
  departureCheckedMailProcessingCenters: PropTypes.arrayOf(PropTypes.string),
  departureExpandedPostalOperators: PropTypes.arrayOf(PropTypes.string),
  retrieveOutboundPostalOperatorsRequestActionCreator: PropTypes.func,
  onSelectAllDepartureMailProcessingCenters: PropTypes.func,
  onDeSelectAllDepartureMailProcessingCenters: PropTypes.func,
  onDeparturePostalOperatorExpandedAdmin: PropTypes.func,
  saveGlobalSelectionImpcRequestActionCreator: PropTypes.func,
  departureMailProcessingCenterCheckedActionCreator: PropTypes.func,
  arrivalPostalOperatorsNodes: PropTypes.arrayOf(PropTypes.object),
  arrivalExpandedPostalOperators: PropTypes.arrayOf(PropTypes.string),
  arrivalCheckedMailProcessingCenters: PropTypes.arrayOf(PropTypes.string),
  selectedArrivalPostalOperatorsNodes: PropTypes.arrayOf(PropTypes.object),
  onArrivalPostalOperatorExpanded: PropTypes.func,
  retrieveInboundPostalOperatorsRequestActionCreator: PropTypes.func,
  arrivalMailProcessingCenterCheckedActionCreator: PropTypes.func,
  onSelectAllArrivalMailProcessingCenters: PropTypes.func,
  onDeSelectAllArrivalMailProcessingCenters: PropTypes.func,
  arrivalSelections: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    impcCodes: PropTypes.arrayOf(PropTypes.string).isRequired,
  })),
  departureSelections: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    impcCodes: PropTypes.arrayOf(PropTypes.string).isRequired,
  })),
  setTabButtonStatus: PropTypes.func,
};

const mapDispatchToProps = dispatch => bindActionCreators({
  retrieveOutboundPostalOperatorsRequestActionCreator,
  departureMailProcessingCenterCheckedActionCreator,
  onDeparturePostalOperatorExpandedAdmin,
  onSelectAllDepartureMailProcessingCenters,
  onDeSelectAllDepartureMailProcessingCenters,
  retrieveInboundPostalOperatorsRequestActionCreator,
  arrivalMailProcessingCenterCheckedActionCreator,
  onArrivalPostalOperatorExpanded,
  onSelectAllArrivalMailProcessingCenters,
  onDeSelectAllArrivalMailProcessingCenters,
  saveGlobalSelectionImpcRequestActionCreator,
  setTabButtonStatus,
}, dispatch);

const mapStateToProps = state => ({
  selectedDeparturePostalOperatorsNodes: getSelectedDeparturePostalOperators(state),
  departurePostalOperatorsNodes: getDeparturePostalOperators(state),
  departureExpandedPostalOperators: getExpandedDeparturePostalOperatorsOperatorImpcAdmin(state),
  departureCheckedMailProcessingCenters: getDepartureCheckedMailProcessingCenters(state),
  arrivalCheckedMailProcessingCenters: getArrivalCheckedMailProcessingCenters(state),
  selectedArrivalPostalOperatorsNodes: getSelectedArrivalPostalOperators(state),
  arrivalPostalOperatorsNodes: getArrivalPostalOperators(state),
  arrivalExpandedPostalOperators: getExpandedArrivalPostalOperators(state),
});

/* Needed for prop-types with cloneElement */
export const ConnectedGlobalPresetsOperatorImpcContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(GlobalPresetsOperatorImpcContainer);

export default (ConnectedGlobalPresetsOperatorImpcContainer);
